import React, { FC } from 'react'
// import './styles.scss'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/grid.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/card.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
// import '@ta-interaktiv/semantic-ui/semantic/dist/components/icon.css'
import styled from 'styled-components'
import ContentGrid from 'components/ContentGrid'
import { ContentWidth, TextWidth } from 'components/Container'
import dataCards from './daten.json'

// console.log('test', dataCards)

export const Cards: FC<{
  title?: string
  lead?: string
  width?: 'full' | 'content' | 'text'
  caption?: string
  source?: string
  colorMode?: string
}> = ({ title, lead, width, caption, source, colorMode }) => {
  return (
    <>
      <ContentGrid>
        <TextWidth>
          <>
            {title && <Title>{title}</Title>}
            {lead && <Lead className='lead'>{lead}</Lead>}
          </>
        </TextWidth>
      </ContentGrid>
      <ContentGrid>
        <TextWidth>
          {colorMode === 'dark' ? (
            <Legend>
              <div className='legendTitle'>Anzahl Hitzetage* pro Jahr</div>
              <div className='legendWrapper'>
                <div className='entry'>
                  <div className='legendColor black'></div>
                  <div>keine</div>
                </div>
                <div className='entry'>
                  <div className='legendColor redFour'></div>
                  <div>bis 2</div>
                </div>
                <div className='entry'>
                  <div className='legendColor redThree'></div>
                  <div>bis 4</div>
                </div>
                <div className='entry'>
                  <div className='legendColor redTwo'></div>
                  <div>bis 7</div>
                </div>
                <div className='entry'>
                  <div className='legendColor redOne'></div>
                  <div>bis 10</div>
                </div>
                <div className='entry'>
                  <div className='legendColor orangeFour'></div>
                  <div>bis 20</div>
                </div>
                <div className='entry'>
                  <div className='legendColor orangeThree'></div>
                  <div>bis 30</div>
                </div>
                <div className='entry'>
                  <div className='legendColor orangeTwo'></div>
                  <div>bis 40</div>
                </div>
                <div className='entry'>
                  <div className='legendColor orangeOne'></div>
                  <div>bis 50</div>
                </div>
                <div className='entry'>
                  <div className='legendColor yellow'></div>
                  <div>über 50</div>
                </div>
              </div>
            </Legend>
          ) : (
            <Legend>
              <div className='legendTitle'>Anzahl Hitzetage* pro Jahr</div>
              <div className='legendWrapper'>
                <div className='entry'>
                  <div className='legendColor white'></div>
                  <div>keine</div>
                </div>
                <div className='entry'>
                  <div className='legendColor yellow'></div>
                  <div>bis 2</div>
                </div>
                <div className='entry'>
                  <div className='legendColor orangeOne'></div>
                  <div>bis 4</div>
                </div>
                <div className='entry'>
                  <div className='legendColor orangeTwo'></div>
                  <div>bis 7</div>
                </div>
                <div className='entry'>
                  <div className='legendColor orangeThree'></div>
                  <div>bis 10</div>
                </div>
                <div className='entry'>
                  <div className='legendColor orangeFour'></div>
                  <div>bis 20</div>
                </div>
                <div className='entry'>
                  <div className='legendColor redOne'></div>
                  <div>bis 30</div>
                </div>
                <div className='entry'>
                  <div className='legendColor redTwo'></div>
                  <div>bis 40</div>
                </div>
                <div className='entry'>
                  <div className='legendColor redThree'></div>
                  <div>bis 50</div>
                </div>
                <div className='entry'>
                  <div className='legendColor redFour'></div>
                  <div>über 50</div>
                </div>
              </div>
            </Legend>
          )}
        </TextWidth>
      </ContentGrid>

      {width === 'full' && (
        <>
          <CardsContainer>
            <div className='ui cards'>
              {dataCards.map(
                (
                  item: {
                    rank?: string
                    map?: string
                    mapDark?: string
                    year?: number
                  },
                  index: number
                ) => {
                  return (
                    <div className='card' key={index}>
                      <div className='imageContainer '>
                        {/* <div className='row'>
                          <div className='rank'>{item.rank}</div>
                        </div> */}
                        <div className='row'>
                          {colorMode === 'dark' ? (
                            <Image
                              src={require(`./icons/${item.mapDark}.png`)}
                            ></Image>
                          ) : (
                            <Image
                              src={require(`./icons/${item.map}.png`)}
                            ></Image>
                          )}
                        </div>
                        <div className='row year'>
                          <div className='year'>{item.year}</div>
                        </div>
                      </div>
                    </div>
                  )
                }
              )}
            </div>
          </CardsContainer>
        </>
      )}

      {width === 'content' && (
        <>
          <ContentGrid>
            <ContentWidth>
              <CardsContainer>
                <div className={'ui cards'}>
                  {dataCards.map(
                    (
                      item: {
                        rank?: string
                        map?: string
                        mapDark?: string
                        year?: number
                      },
                      index: number
                    ) => {
                      return (
                        <div className='card' key={index}>
                          <div className='imageContainer '>
                            {/* <div className='row'>
                              <div className='rank'>{item.rank}</div>
                            </div> */}
                            <div className='row'>
                              {colorMode === 'dark' ? (
                                <Image
                                  src={require(`./icons/${item.mapDark}.png`)}
                                ></Image>
                              ) : (
                                <Image
                                  src={require(`./icons/${item.map}.png`)}
                                ></Image>
                              )}
                            </div>
                            <div className='row year'>
                              <div className='year'>{item.year}</div>
                            </div>
                          </div>
                        </div>
                      )
                    }
                  )}
                </div>
              </CardsContainer>
            </ContentWidth>
          </ContentGrid>
        </>
      )}
      <ContentGrid>
        <TextWidth>
          <Caption>
            {caption && caption}
            {source && <Source>{source}</Source>}
          </Caption>
        </TextWidth>
      </ContentGrid>
    </>
  )
}

const Image = ({ src, className }: { src?: string; className?: string }) => {
  return (
    <img src={src} alt='icon' className={`ui fluid image + ${className}`}></img>
  )
}

const CardsContainer = styled.div<{ tenant?: string }>`
  /* overflow: hidden; */
  /* max-width: 1072px !important; */
  margin-left: auto;
  margin-right: auto;
  font-size: 18px;
  margin-top: 1em;
  .grid {
    margin: 0;
    padding: 0;
    width: 100%;
  }
  /* .grid > .column {
    box-shadow: 2px 2px 8px rgb(0 0 0 / 10%), 0 0 2px rgb(0 0 0 / 10%);
    border-radius: 5px;
  } */
  .cards {
    justify-content: start;
    width: 100%;
    margin: 0;
  }
  .cards > .card {
    /* box-shadow: 2px 2px 8px rgb(0 0 0 / 10%), 0 0 2px rgb(0 0 0 / 10%); */
    /* border-radius: 5px; */
    background-color: transparent;
  }

  .ui.cards > .card {
    /* margin: 0.5rem 0.25rem; */
    width: calc(100% / 10);
    margin: 0;

    @media only screen and (max-width: 1679px) {
      width: calc(100% / 8);
    }

    @media only screen and (max-width: 1071px) {
      width: calc(100% / 6);
    }

    @media only screen and (max-width: 599px) {
      width: calc(100% / 5);
    }

    @media only screen and (max-width: 420px) {
      width: calc(100% / 4);
    }

    /* height: 100%; */
  }

  .imageContainer {
    /* color: white; */

    padding: 0.5rem 0.25rem;
    @media only screen and (max-width: 599px) {
      padding: 0.5rem 0.25rem 0.25rem 0.25em;
    }
    text-align: center;
    line-height: 1.3;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    img {
      width: 100%;
    }
  }

  /* .ui.cards > .card > .content {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .ui.cards > .card > .content::after {
    content: none;
  } */
  .row {
    .rank {
      color: var(--text-color);
      font-size: 12px;
    }
  }

  .row.year {
    margin-top: 0.5rem;
    .year {
      font-size: 0.9em;
      color: #7d7d7d;
      @media only screen and (max-width: 711px) {
        font-size: 15px;
      }
      @media only screen and (max-width: 450px) {
        font-size: 14px;
      }
    }
  }
`
const Legend = styled.div<{ tenant?: string }>`
  color: var(--text-color);
  font-size: 15px;
  /* margin-top: 1em; */

  .legendTitle {
    font-weight: 700;
    margin-bottom: 0.25em;
  }

  .legendWrapper {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    font-size: 1.5em;
  }

  .entry {
    display: flex;
    flex-direction: column;
    justify-content: baseline;
    align-items: center;
    padding: 0.2em 0.15em;
    white-space: nowrap;
    width: 50px;
    font-size: 15px;
  }
  .legendColor {
    width: 10px;
    height: 10px;
    border-radius: 50%;
  }
  .legendColor.white {
    background-color: #fff;
    border: 1px solid #d4d4d4;
  }
  .legendColor.yellow {
    background-color: #ffff8f;
    border: 1px solid #d4d4d4;
  }
  .legendColor.orangeOne {
    background-color: #fed679;
    border: 1px solid #d4d4d4;
  }
  .legendColor.orangeTwo {
    background-color: #fbba5b;
    border: 1px solid #d4d4d4;
  }
  .legendColor.orangeThree {
    background-color: #f99c4f;
    border: 1px solid #d4d4d4;
  }
  .legendColor.orangeFour {
    background-color: #e76636;
    border: 1px solid #d4d4d4;
  }
  .legendColor.redOne {
    background-color: #d62f27;
    border: 1px solid #d4d4d4;
  }
  .legendColor.redTwo {
    background-color: #b50626;
    border: 1px solid #d4d4d4;
  }
  .legendColor.redThree {
    background-color: #6b0026;
    border: 1px solid #d4d4d4;
  }
  .legendColor.redFour {
    background-color: #2b0016;
    border: 1px solid #d4d4d4;
  }
  .legendColor.black {
    background-color: #121212;
    border: 1px solid #d4d4d4;
  }
`
const Caption = styled.figcaption`
  color: var(--text-color);
  font-family: var(--font-sans-serif);
  font-size: 1.5rem;
  line-height: 2.1rem;
  margin-top: 1.5rem;

  /* &.top {
    margin-top: 1.5rem;
  }

  &.bottom.true {
    margin-top: 1.5rem;
  } */

  .source {
    margin-top: 0.5em;
    font-weight: 400;
    color: var(--gray-3);
    font-size: 1.2rem;
    line-height: 1.8rem;
  }
`
const Source = styled.div`
  margin-top: 0.5em;
  font-weight: 400;
  color: var(--gray-3);
  font-size: 1.2rem;
  line-height: 1.8rem;
  margin-bottom: 30px;
  /* &.bottom {
    margin-top: 0.3rem;
  } */
`

const Title = styled.h3`
  color: var(--text-color);
  margin: 0;
  font-size: 18px !important;
  line-height: 2.4rem;
  margin-bottom: 2rem;

  &.bottom {
    margin-top: 1.5rem;
    font-size: 1.5rem !important;
    line-height: 2.1rem;
    margin-bottom: 0;
  }
`
const Lead = styled.div`
  color: var(--text-color);
  font-size: 15px;
  width: 100%;
  font-style: normal;
  font-weight: 400;
  line-height: 2.3rem;
  margin: 0;
  margin-bottom: 2rem;
  &.bottom {
    line-height: 2.1rem;
    margin-bottom: 0;
  }
  &.top {
    margin-bottom: 1.5rem;
  }
`
